import { createAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import { OrderBy } from '../model/order-by.model';

export interface SortItems {
    orderBy?: OrderBy;
}

export const sortItems = createAction<ActionType, SortItems>(
    ActionType.NOTI__EC__SORT_ITEMS,
);
